import { createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { fetchCustomerGroups } from './customerGroupSlices';

const fetchCustomerGroups$ = createEpicFromAsyncActionEmptyRequest(
    fetchCustomerGroups,
    ({ customerGroupsClient }) => customerGroupsClient.getAll()
);
export default [fetchCustomerGroups$];
